// extracted by mini-css-extract-plugin
export default {"buttons":"Basic_buttons__4f0Nq"};